import { useEffect, useState } from "react";
import { columnSettings } from "./report-template-setting";
import { set } from "date-fns";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateSummary = (props) => {
  const { list, listRaw, groupNames, groupMap } = props;

  const [jenisMinyak, setJenisMinyak] = useState("");
  const [diffKm, setDiffKm] = useState(0);
  const [liter, setLiter] = useState(0);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    let _jenisMinyak = "";
    let _diffKm = 0;
    let _liter = 0;
    let _total = 0;

    let firstJenisMinyak = "";
    if (listRaw && listRaw.length > 0) {
      _diffKm =
        listRaw[listRaw.length - 1].speedo_akhir - listRaw[0].speedo_akhir || 0;

      _jenisMinyak = listRaw[0].data_jenis_minyak.nama;
      firstJenisMinyak = _jenisMinyak;

      for (const pengisian of list) {
        if (pengisian.jenis_minyak !== firstJenisMinyak) {
          _jenisMinyak = "-";
        }
        _liter += pengisian.jumlah;
        _total += pengisian.total_harga;
      }
    }

    setJenisMinyak(_jenisMinyak);
    setDiffKm(_diffKm);
    setLiter(_liter);
    setTotal(_total);
  }, [list, listRaw, groupNames, groupMap]);

  return (
    <table>
      <tbody>
        <tr className="row-start-start w-full text-sm text-slate-700 !items-stretch">
          <td
            className={`row-start-center font-bold w-[14.5rem] border-zinc-300 border px-2 pt-2 pb-1 `}
          >
            GRANDTOTAL
          </td>

          <td
            className={`font-bold ${settings["jenis_minyak"].layout} ${settings["jenis_minyak"].width} border-zinc-300 border border-l-0 px-2 pt-2 pb-1 `}
          >
            {/* {jenisMinyak} */}
          </td>

          <td
            className={`font-bold ${settings["jumlah"].layout} ${settings["jumlah"].width} border-zinc-300 border border-l-0 px-2 pt-2 pb-1 `}
          >
            {liter ? liter.toLocaleString("id-ID") : "-"}
          </td>

          <td
            className={`font-bold ${settings["harga_per_liter"].layout} ${settings["harga_per_liter"].width} border-zinc-300 border border-l-0 px-2 pt-2 pb-1 `}
          >
            {/* {harga_per_liter ? harga_per_liter.toLocaleString("id-ID") : "-"} */}
          </td>

          <td
            className={`font-bold ${settings["total_harga"].layout} ${settings["total_harga"].width} border-zinc-300 border border-l-0 px-2 pt-2 pb-1 `}
          >
            {total ? total.toLocaleString("id-ID") : "-"}
          </td>

          <td
            className={`font-bold ${settings["speedo_akhir"].layout} ${settings["speedo_akhir"].width} border-zinc-300 border border-l-0 px-2 pt-2 pb-1 `}
          >
            {diffKm ? diffKm.toLocaleString("id-ID") : "-"}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default ReportTemplateSummary;
